<template>
  <div class="ti-application-infos">
    <button
      class="ti-application-infos__button wb-round-button wb-round-button--solid-level-0 wb-round-button--medium"
      type="button"
      @click="toggleInfos"
    >
      <wb-icon name="settings"></wb-icon>
    </button>

    <div class="ti-application-infos__popover" v-if="open">
      <div
        class="ti-application-infos__popover-backdrop"
        @click="toggleInfos"
      ></div>

      <div class="ti-application-infos__popover-content">
        <div class="wb-list-group__items wb-list-group--settings">
          <div
            type="button"
            class="wb-list-group__item wb-list-group__item--fullwidth"
          >
            <div class="wb-list-group__heading">Market</div>

            <wb-select-control>
              <wb-select>
                <label>Configuration</label>

                <select v-model="settings.configurationId">
                  <option
                    v-for="configuration in configurations"
                    v-bind:value="configuration.value"
                  >
                    {{ configuration.label }} - {{ configuration.value }}
                  </option>
                </select>
              </wb-select>
            </wb-select-control>
          </div>

          <div
            type="button"
            class="wb-list-group__item"
            v-if="enableEnvironmentChooser && applicationInfos.environment"
          >
            <div class="wb-list-group__heading">Environment</div>

            <wb-button-group>
              <label
                class="wb-button wb-button--secondary wb-button--small"
                :class="{
                  'wb-button--current':
                    environment.label === applicationInfos.environment,
                }"
                @click="changeEnvironment(environment.value)"
                v-for="environment in environments"
              >
                <input type="radio" name="environment" />
                {{ environment.label.toUpperCase() }}
              </label>
            </wb-button-group>
          </div>

          <div
            class="wb-list-group__item wb-list-group__item--fullwidth"
            v-if="showMeToken"
          >
            <div class="wb-list-group__heading">Mercedes me Token</div>
            <wb-input-control>
              <wb-input>
                <label>JWE Token</label>
                <input v-model="settings.meToken" type="text" />
              </wb-input>
            </wb-input-control>
          </div>

          <div
            class="wb-list-group__item wb-list-group__item--fullwidth"
            v-if="showMeToken"
          >
            <wb-select-control>
              <wb-select>
                <label>WKO Type</label>
                <select v-model="settings.selectedWKOType">
                  <option v-for="type in wkoTypes" v-bind:value="type">
                    {{ type }}
                  </option>
                </select>
              </wb-select>
            </wb-select-control>
          </div>

          <div type="button" class="wb-list-group__item">
            <wb-button-group>
              <label
                class="wb-button wb-button--secondary wb-button--large"
                @click="applySettings()"
              >
                <input type="radio" name="apply" />
                Apply settings
              </label>
            </wb-button-group>
          </div>
        </div>

        <div class="wb-list-group__items">
          <div class="wb-list-group__item" v-if="applicationInfos.environment">
            Buildenvironment: {{ applicationInfos.environment }}
          </div>
          <div class="wb-list-group__item" v-if="applicationInfos.buildDate">
            Builddate: {{ applicationInfos.buildDate }}
          </div>
          <div class="wb-list-group__item" v-if="applicationInfos.buildVersion">
            Buildversion: {{ applicationInfos.buildVersion }}
          </div>
          <div class="wb-list-group__item" v-if="applicationInfos.buildBranch">
            Buildbranch: {{ applicationInfos.buildBranch }}
          </div>
          <div class="wb-list-group__item" v-if="applicationInfos.apiUrl">
            Backendurl: {{ applicationInfos.apiUrl }}
          </div>

          <template v-if="applicationInfos.backendInfos">
            <div
              class="wb-list-group__item"
              v-if="applicationInfos.backendInfos.buildTime"
            >
              BE Buildtime: {{ applicationInfos.backendInfos.buildTime }}
            </div>
            <div
              class="wb-list-group__item"
              v-if="applicationInfos.backendInfos.version"
            >
              BE Buildversion: {{ applicationInfos.backendInfos.version }}
            </div>
            <div
              class="wb-list-group__item"
              v-if="applicationInfos.backendInfos.gitCommit"
            >
              BE Git-Commit: {{ applicationInfos.backendInfos.gitCommit }}
            </div>
          </template>

          <div class="wb-list-group__item wb-list-group__item--space-around">
            <wb-toggle-control>
              <label>
                <input
                  type="checkbox"
                  @click="toggleGrid()"
                  :checked="showGrid"
                />Toggle Grid</label
              >
            </wb-toggle-control>

            <wb-toggle-control>
              <label>
                <input
                  type="checkbox"
                  @click="toggleStage()"
                  :checked="disableStage"
                />Disable Stage</label
              >
            </wb-toggle-control>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { addGridStyling } from '@tradein/utils';
import setup from '../../composables/setup';

interface Settings {
  configurationId?: string;
  environment?: string;
  meToken?: string;
  selectedWKOType?: string;
}

const { configurationId, applicationInfos } = setup();
const enableEnvironmentChooser = ref(false);
const open = ref(false);
const settings = ref({} as Settings);
const disableStage = ref(false);
const showGrid = ref(false);
const showMeToken = ref(false);
const wkoTypes = ref([]);

const environments = [
  {
    label: 'local',
    value: '/environments/local.config.json',
  },
  {
    label: 'test',
    value: '/environments/test.config.json',
  },
  {
    label: 'dev',
    value: '/environments/dev.config.json',
  },
  {
    label: 'int',
    value: '/environments/int.config.json',
  },
];

const configurations = [
  {
    label: 'Germany',
    value: 'de-DE-one',
  },
  {
    label: 'South Africa',
    value: 'en-ZA-one',
  },
  {
    label: 'India',
    value: 'en-IN-one',
  },
  {
    label: 'Belgium NL',
    value: 'nl-BE-one',
  },
  {
    label: 'Belgium FR',
    value: 'fr-BE-one',
  },
  {
    label: 'Netherland NL',
    value: 'nl-NL-one',
  },
  {
    label: 'Mexico',
    value: 'es-MX-one',
  },
];

const configurationIdKey = 'tradein-configurationid';
const meTokenKey = 'tradein-metoken';
const wkoTypeKey = 'tradein-wkotype';

const emit = defineEmits(['applySettings', 'disableStage']);
onMounted(() => {
  settings.value.configurationId = configurationId.value;
  enableEnvironmentChooser.value =
    location.hostname === 'localhost' ||
    location.hostname === '127.0.0.1' ||
    location.hostname.includes(
      'int-publish.mbmxp.aem.oneweb.mercedes-benz.com',
    );

  import('@tradein/utils/src/wko').then((mockWKO) => {
    wkoTypes.value = mockWKO.mockTypes.map((type) => type.type) as any;
  });

  addGridStyling();
  setMeToken();
  toggleStage(true);
});

const changeEnvironment = (environment: string): void => {
  settings.value.environment = environment;
};

const applySettings = (): void => {
  console.log(settings.value);
  settings.value.environment &&
    window.localStorage.setItem(
      'tradein-environment',
      settings.value.environment,
    );

  settings.value.configurationId &&
    window.localStorage.setItem(
      configurationIdKey,
      settings.value.configurationId,
    );

  settings.value.meToken
    ? window.localStorage.setItem(meTokenKey, settings.value.meToken)
    : window.localStorage.removeItem(meTokenKey);

  settings.value.selectedWKOType
    ? window.localStorage.setItem(wkoTypeKey, settings.value.selectedWKOType)
    : window.localStorage.removeItem(wkoTypeKey);

  emit('applySettings');
  window.location.reload();
};

const toggleInfos = (): void => {
  open.value = !open.value;
};

const toggleGrid = (): void => {
  const gridClass = 'wb-grid-debugger';
  document.body.classList.toggle(gridClass);
  showGrid.value = document.body.classList.contains(gridClass);
};

const toggleStage = (init = false): void => {
  !init &&
    window.localStorage.setItem(
      'tradein-disable-stage',
      disableStage.value ? 'false' : 'true',
    );
  disableStage.value =
    window.localStorage.getItem('tradein-disable-stage') === 'true';
  emit('disableStage', disableStage.value);
};

const setMeToken = (): void => {
  settings.value.configurationId =
    window.localStorage.getItem(configurationIdKey) || '';
  settings.value.meToken = window.localStorage.getItem(meTokenKey) || '';
  settings.value.selectedWKOType =
    window.localStorage.getItem(wkoTypeKey) || '';
  showMeToken.value = true;
};
</script>
<style lang="scss" src="./application-infos.scss"></style>
